
























































import Vue, { PropType } from "vue";

export interface Props {
  lang: any;
  cardLang: any;
  contractNumber: string;
  contractTitle: string;
  contractDescription: string;
  pauseStartAt: number;
  pauseTermList: any;
  resumeDateList: any;
  registerUrl: string;
  returnUrl: string;
  isButtonDisabled: boolean;
}

export interface Data {
  currentTerm: 1 | 2 | 3;
  isButtonDisabled: boolean;
}

export default Vue.extend({
  name: "vc-pause-reserve-form",
  props: {
    lang: {
      type: Object as PropType<Props["lang"]>,
      default: () => {}
    },
    cardLang: {
      type: Object as PropType<Props["cardLang"]>,
      default: () => {}
    },
    contractNumber: {
      type: String as PropType<Props["contractNumber"]>,
      default: ""
    },
    contractTitle: {
      type: String as PropType<Props["contractTitle"]>,
      default: ""
    },
    contractDescription: {
      type: String as PropType<Props["contractDescription"]>,
      default: ""
    },
    pauseStartAt: {
      type: Number as PropType<Props["pauseStartAt"]>,
      default: 0
    },
    pauseTermList: {
      type: Object as PropType<Props["pauseTermList"]>,
      default: () => {}
    },
    resumeDateList: {
      type: Object as PropType<Props["resumeDateList"]>,
      default: () => {}
    },
    registerUrl: {
      type: String as PropType<Props["registerUrl"]>,
      default: ""
    },
    returnUrl: {
      type: String as PropType<Props["returnUrl"]>,
      default: ""
    }
  },
  data(): Data {
    return {
      currentTerm: 3,
      isButtonDisabled: false
    };
  },
  methods: {
    onClickReturnButton() {
      if (this.returnUrl === "") return;

      this.isButtonDisabled = true;
      window.location.href = this.returnUrl;
    },
    onClickPauseButton() {
      if (this.registerUrl === "") return;

      this.isButtonDisabled = true;

      const url = new URL(this.registerUrl);
      url.searchParams.append("pauseTerm", this.currentTerm.toString());

      window.location.href = url.toString();
    }
  }
});
